import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, Grid, IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {getAddresse, getDataInString} from "../RightAccordion";
import IconesRight from "../../pages/compos/IconesRight";
import InfoIcon from "@mui/icons-material/Info";
import IconMaison from "../../ico/IconMagasin";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import HeightIcon from "@mui/icons-material/Height";
import IconEtage2 from "../../ico/IconEtage2";
import IconMSquare2 from "../../ico/IconMSquare2";
import IconMur from "../../ico/IconMur";
import IconToit from "../../ico/IconToit";
import {resBdnb} from "../AttributBdnb";
import {sumItem} from "./BatimentsDetails";


function getListOfPrpprietaires(proprietaires) {
    let res = []
    proprietaires.forEach(element => {
        let n = ""
        if(element?.forme_juridique) {
            n += element?.forme_juridique + " "
        }
        if(element?.denomination) {
            n += element?.denomination + " "
        }
        if(element?.siren) {
            n += "(" + element?.siren + ")"
        }
        if (element?.nb_locaux_open){
            n += " - "+ element.nb_locaux_open + " loc."
        }
        res.push(n)
    })
    return res.join("<br>");
}

export default function RNCDetails({selectedItem}) {
    const [open, setOpen] = React.useState(true);

    return (<Box>

            <Box sx={{
                width: "90%",
                borderRadius: "8px",
                backgroundColor: "#f7f9fc",
                padding: 2,
                m: 1,
            }}>
                <Box sx={{
                    display: "flex",
                    width: "100%",
                    borderColor: "#000",
                    borderBottomStyle: "solid",
                    height: 30
                }}>
                    <Typography>REGISTRE DES COPROPRIÉTÉS</Typography>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Immeuble en copropriété</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {selectedItem.metadonnees[0].l_nom_copro ? "Oui" : "Non"}
                        </Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Nom de la copropriété</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem?.metadonnees[0]?.l_nom_copro?.replaceAll("{", "").replaceAll("}", "").replaceAll('"', '')}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Numéro immatriculation principale copropriété</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem.metadonnees[0].numero_immat_principal}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Type de syndic</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {selectedItem?.rnc[0]?.typedesyndicbenevoleprofessionnelnonconnu}
                        </Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Identification du représentant légal</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem?.rnc[0]?.identificationdurepresentantlegal}</Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>SIRET du représentant légal</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem?.rnc[0]?.siretdurepresentantlegal}</Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Code APE</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem?.rnc[0]?.codeape}</Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Commune du représentant légal</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem?.rnc[0]?.communedurepresentantlegal}</Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Mandat en cours ?</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem?.rnc[0]?.mandatencoursdanslacopropriete}</Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Date de fin du dernier mandat</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem?.rnc[0]?.datedefinduderniermandat}</Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Date du règlement de copropriété</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>{selectedItem?.rnc[0]?.datedureglementdecopropriete}</Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Nombre de logement dans la copropriété</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom> {sumItem(selectedItem.metadonnees,"nb_log")}</Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Nombre de lot teritiaire dans la copropriété</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {sumItem(selectedItem.metadonnees,"nb_lot_tertiaire")}
                        </Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Nombre de lot parking dans la copropriété</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {sumItem(selectedItem.metadonnees,"nb_lot_garpark")}
                        </Typography>

                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,

                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Nombre de lot total dans la copropriété</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {sumItem(selectedItem.metadonnees,"nb_lot_tot")}
                        </Typography>
                    </Box>
                </Box>

            </Box>
        </Box>
    )
}

